import React from 'react';
import If from '../../../../../vendors/components/If';
import EventoVisualizarController from '../controller/evento-visualizar.controller';
import EventoModel from '../../../../shared/model/evento.model';

interface Props {
  controller: EventoVisualizarController;
  evento: EventoModel;
}

export default function EventoVisualizarHeader({ controller, evento }: Props) {

  return (
    <>
      <>
        <div style={{ paddingTop: '10px' }} className="flex align-items-center">
          <If condition={controller.show}>
            <i style={{ fontSize: '25px', cursor: 'pointer' }} onClick={() => controller.handleShow()} className="pi pi-angle-left" />
          </If>
          <If condition={!controller.show}>
            <i style={{ fontSize: '25px', cursor: 'pointer' }} onClick={() => controller.handleShow()} className="pi pi-angle-right" />
          </If>
          <h3 style={{ marginLeft: '10px' }}>{!!evento.cdTpEventoNavigation ? evento.cdTpEventoNavigation.dsTpEvento : ''}</h3>
        </div>
      </>
    </>
  );
}